module.exports = __webpack_public_path__ + "img/mj-logo-blue.3d4829ad.png";